import axios from 'axios';
import {backendHost} from '../../config';

export const putRole = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/roles`, params);
};